import React from 'react'
import styled from '@emotion/styled'

import Select from '../../form/Select'

const Root = styled.div`
  display: flex;
  padding-top: 3px;
  align-items: baseline;
  color: #333;
`

const Title = styled.span`
  flex-shrink: 0;
  padding-right: 3px;
`

const SortBar = ({
  options,
  sort,
  setSort,
}) => <Root>
  <Title>Сортировка:</Title>
  <Select options={options} value={sort} setValue={setSort}/>
</Root>

export default SortBar
